import { render, staticRenderFns } from "./salesAnalysisChart.vue?vue&type=template&id=3b5772e0&scoped=true"
import script from "./salesAnalysisChart.vue?vue&type=script&lang=js"
export * from "./salesAnalysisChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5772e0",
  null
  
)

export default component.exports